<template>
  <div>
    <hg-dialog :title="dType[dialogType]" :width="800" :height="400" :visible="dialogVisible" @close="handleClose">
      <div v-loading="loading">
        <my-content ref="ref" :ruleForm.sync="formData" :dialogType="dialogType" />
      </div>
      <div slot="footer" style="width:100%;text-align: right">
        <el-button size="small" icon="el-hg-icon-save" type="primary" v-if="dialogType!=='detail'" v-permission="'713'" @click="submit">保 存</el-button>
        <el-button size="small" icon="el-hg-icon-save" type="primary" v-if="dialogType === 'detail'" plain @click="$emit('update:dialogType', 'update')">修 改</el-button>
        <el-button size="small" icon="el-hg-icon-close" type="danger" @click="handleClose">关 闭</el-button>
      </div>
    </hg-dialog>
  </div>
</template>
<script>
import HgDialog from '@/components/dialog';
import MyContent from './content';

// const
export default {
  name: 'MyDialog',
  components: {
    MyContent,
    HgDialog
  },
  props: {
    id: { type: String },
    dialogType: { type: String },
    show: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      dialogVisible: false,
      loading: false,
      dType: {
        insert: '通用字典配置新增',
        update: '通用字典配置修改',
        detail: '通用字典配置详情'
      },
      originData: {}, // 副本，判断是否更改数据
      formData: {
        dicCode: '',
        dicName: '',
        dicValue: '',
        dicType: '',
        dicExplain: '',
        state: 0,
        remark1: ''
      }
    };
  },
  methods: {
    async save(param) {

      let params = JSON.parse(JSON.stringify(param));
      params.updateFlg = this.id ? 'update' : 'add';

      const { status, msg } = await this.$services.postJson({
        type: 'SYSDICCOMMS',
        url: 'saveSysDicControllerAssessMainSave',
        params
      });
      if (status) {
        this.$message({
          message: this.id ? '修改成功' : '添加成功',
          type: 'success'
        });
        // reset form
        this.$refs['ref'].$refs['ruleForm'].resetFields();

        this.$emit('refresh');
        this.handleClose();
      }
      else {
        this.$message({
          message: msg,
          type: 'info'
        });
      }
    },
    async getDetail() {
      this.loading = true;
      const { bean } = await this.$services.post({
        type: 'SYSDICCOMMS',
        url: 'getSysDicControllerDicCalculationDetail',
        params: { id: this.id }
      });
      this.formData = bean;
      this.originData = this.$utils.deepCopy(bean);
      this.loading = false;
    },
    submit() {
      let child = this.$refs['ref'].$refs['ruleForm'];
      child.validate(valid => {
        if (valid) {
          console.warn('submit!');
          this.save(this.formData);
        }
        else {
          console.warn('error submit!!');
          return false;
        }
      });
    },
    clearForm() {
      this.formData = {
        dicCode: '',
        dicName: '',
        dicValue: '',
        dicType: '',
        dicExplain: '',
        state: 0,
        remark1: ''
      };
    },
    handleClose() {
      if (this.dialogType === 'update' && this.$utils.targetIsChange(this.originData, this.formData)) {
        this.$confirm('是否不保存离开', '提示', {
          dangerouslyUseHTMLString: true,
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
          .then(() => {
            this.clearForm();
            this.dialogVisible = false;
            this.$emit('close', 'insert');
          })
          .catch(() => {
            this.$message({
              type: 'info',
              message: '已取消关闭'
            });
          });
      }
      else {
        this.clearForm();
        this.dialogVisible = false;
        this.$emit('close', 'insert');
      }

    }
  },
  // dialog show
  watch: {
    show(val) {
      if (val) {
        this.dialogVisible = true;
        if (this.id) {
          this.getDetail();
        }
      }
      else {
        this.dialogVisible = false;
      }
    }
  }
};
</script>
<style lang="scss" scoped>
</style>
